import React from "react";
import TeamCard from "../components/TeamCard";
import Footer from "components/Footer";
import Section4 from "components/Section4";
import TeamFaq from "components/TeamFaq";

const teamMembers = [
    // {
    //     name: "Dinesh Kumar",
    //     title: "Founder & CEO",
    //     description: "Dinesh Kumar is the visionary founder and CEO of Minterminds IT Company.",
    //     imageUrl: "/ceo.png",
    // },

    {
        name: "Rosenda Campo",
        title: "Business Operations and Growth Manager",
        description: "Strong background in streamlining processes and identifying Growth Opportunities.",
        imageUrl: "/team2.jpeg",
    },
      {
        name: "Genne B. Suplido",
        title: "Social Media & Talent Developemnt Manager",
        description: "With a combined background in social media management, virtual assistance, coaching, and team coordination.",
        imageUrl: "/team5.jpeg",
    },
    {
        name: "Klaidy Rose E. Cortez",
        title: "Business Growth Associate",
        description: "Support business growth through marketing campaigns, lead generation, strategic partnerships, and customer outreach. Take ownership of growth initiatives and contribute to building DineCircuit into a leading restaurant technology platform.",
        imageUrl: "/Klaide.png",
    },
    {
        name: "Febbie Joy Marino Juan",
        title: "Business Growth Partner | FurryMet",
        description: "Content Creator • Brand Strategist • Marketing Consultant. Helping pet businesses scale with content, technology & partnerships. Creating opportunities that connect brands with pet lovers worldwide.",
        imageUrl: "/febs.png",
    },
   
    
    {
        name: "Elvie Embudo",
        title: "Business Growth Associate",
        description: "Drive business growth by executing marketing campaigns, generating qualified leads, building strategic partnerships, and engaging pet owners, veterinarians, pet businesses, and animal lovers. Take ownership of growth initiatives and play a key role in establishing Furrymet as a leading pet care and community platform.",
        imageUrl: "/elviii.png",
    },
    {
        name: "Editha Benigay Para",
        title: "Marketing Assistant",
        description: "A detail-oriented marketing assistant with strong communication skills, focused on supporting campaigns, engaging customers, and promoting brand growth.",
        imageUrl: "/para.png",
    },
     {
        name: "Sarah Jane U. Cantonjos",
        title: "Growth & Engagement Specialist",
        description: "Dynamic specialist focused on driving user growth and fostering meaningful engagement.",
        imageUrl: "/sarahteam.jpeg",
    },
    {
        name: "Nelson Geonzon",
        title: "Field Business Growth Executive",
        description: "Specializes in expanding market reach and driving on-ground business growth. ",
        imageUrl: "/team3.jpeg",
    },
    {
        name: "Jessa Glorioso",
        title: "Content Creator / Vlogger",
        description: " Creative and passionate storyteller who brings ideas to life through engaging visual content. With a background in beauty and lifestyle vlogging.",
        imageUrl: "/team4.jpg",
    },
    {
        name: "Grazielle Anne",
        title: "Growth & Engagement Specialist",
        description: "Dynamic specialist focused on driving user growth and fostering meaningful engagement.",
        imageUrl: "/team1.jpeg",
    } 
    
];

const Teams: React.FC = () => {
    return (
        <div>
            <div className="max-w-6xl mx-auto px-4 py-16">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-5xl font-bold !leading-tight text-[#333] mb-2">
                        Meet the Team that makes<br />
                        <span className="text-green-700">the Magic happen</span>
                    </h2>
                    <p className="text-[#888] font-semibold text-sm md:text-base max-w-2xl mx-auto">
                        Meet our diverse team of world-class creators, designers, and problem solvers.
                    </p>
                </div>

                <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {teamMembers.map((member, index) => (
                        <TeamCard
                            key={index}
                            {...member}
                        nameColor={member.name === "Dinesh Kumar" ? "text-[#3087b7]" : "text-gray-900"}
                        />
                    ))}
                </div>

                <div className="text-center mb-12 pt-24">
                    <Section4 />
                </div>

                <TeamFaq />
            </div>
            <Footer />
        </div>
    );
};

export default Teams;
